import React from 'react';
import WizardFormFooter from 'components/wizard/WizardFormFooter';
import WizardForm from 'components/wizard/WizardForm';
import WizardNav from 'components/wizard/WizardNav';
import WizardSuccessStep from 'components/wizard/WizardSuccessStep';
import useWizardForm from 'hooks/useWizardForm';
import WizardFormProvider from 'providers/WizardFormProvider';
import WizardCampaignDescForm from 'components/forms/WizardCampaignDescForm';
import WizardCampaignAdvForm from 'components/forms/WizardCampaignAdvForm';
import WizardOutboundRulesForm from 'components/forms/WizardOutboundRulesForm';
import WizardCallingListsForm from 'components/forms/WizardCallingListsForm';

import { Card, Tab } from 'react-bootstrap';

export interface WizardFormData {
  id?: number;
  bxpid: number;
  name: string;
  description: string;
  serviceid: number;
  campaigntype: number;
  bxpname: string;
  callernumber: string;
  timeschedule: { id: number; shortname: string };
  callrecording: boolean;
  mediagroup: { id: number; shortname: string };
  routingdn: string;
  amd: boolean;
  greeting: { id: number; shortname: string };
  active: boolean;
  inbound_lookup_method: 'DATABASE' | 'API';
  outboundRuleAssociations?: Array<{
    id?: number;
    campaign_id: number;
    outrule_id: number;
    limitcall: number;
    weight: number;
    dialpattern: string;
  }>;
  callingListAssociations?: Array<{
    id?: number;
    campaign_id: number;
    callinglist_id: number;
    treatment_id: number;
    filterby: string;
    orderby: string;
    active: boolean;
  }>;
}

interface CampaignWizardFormProps {
  initialData?: Partial<WizardFormData>;
  renderFooter?: (
    isLastStep: boolean,
    formData: WizardFormData
  ) => React.ReactNode;
}

export const CampaignWizardForm: React.FC<CampaignWizardFormProps> = ({
  initialData,
  renderFooter
}) => {
  const form = useWizardForm<WizardFormData>({
    totalStep: 5,
    validation: true,
    initialValues: initialData
  });

  const { selectedStep, totalStep, formData } = form;

  return (
    <WizardFormProvider {...form}>
      <Card className="theme-wizard mx-n6 px-n6 my-n3 py-n3 border-0">
        <Card.Header className="bg-body-highlight px-6 pt-3 pb-2 border-bottom-0 rounded-0">
          <WizardNav />
        </Card.Header>
        <Card.Body className="px-6">
          <Tab.Content>
            <Tab.Pane eventKey={1}>
              <WizardForm step={1}>
                <WizardCampaignDescForm />
              </WizardForm>
            </Tab.Pane>
            <Tab.Pane eventKey={2}>
              <WizardForm step={2}>
                <WizardCampaignAdvForm />
              </WizardForm>
            </Tab.Pane>
            <Tab.Pane eventKey={3}>
              <WizardForm step={3}>
                <WizardOutboundRulesForm campaignId={formData.bxpid} />
              </WizardForm>
            </Tab.Pane>
            <Tab.Pane eventKey={4}>
              <WizardForm step={4}>
                <WizardCallingListsForm campaignId={formData.bxpid} />
              </WizardForm>
            </Tab.Pane>
            <Tab.Pane eventKey={5}>
              <WizardSuccessStep />
            </Tab.Pane>
          </Tab.Content>
        </Card.Body>
        <Card.Footer className="border-top-0 pt-0 pb-2">
          <WizardFormFooter />
        </Card.Footer>
        {renderFooter && renderFooter(selectedStep === totalStep, formData)}
      </Card>
    </WizardFormProvider>
  );
};

export default CampaignWizardForm;
